import type { Subscription } from "le-coffre-resources/dist/Admin";
import type { QueryPayload, RequestOptions } from "../../../../types";
import type { IBaseAdmin } from "../../BaseAdminFactory";
import type { IPostSubscriptionsParams, IPutSubscriptionsParams } from "../Subscriptions";

export function createSubscriptionsGetMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (q?: QueryPayload, options?: RequestOptions): Promise<Subscription[]> => {
		const url = new URL(baseUrl);
		if (q) {
			baseAdmin.appendJsonSearchParams(url, q);
		}
		try {
			return await baseAdmin.getRequest<Subscription[]>(url, options);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createSubscriptionsPostMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (body: IPostSubscriptionsParams): Promise<unknown> => {
		const url = new URL(baseUrl.concat(`/invite`));
		try {
			return await baseAdmin.postRequest(url, body);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createSubscriptionsPutMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, body: IPutSubscriptionsParams): Promise<unknown> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			return await baseAdmin.putRequest(url, body);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createSubscriptionsLifecyclePostMethod(baseAdmin: IBaseAdmin, baseUrl: string, action: "cancel" | "reactivate") {
	return async (uid: string): Promise<Subscription> => {
		const url = new URL(baseUrl.concat(`/${uid}/${action}`));
		try {
			return await baseAdmin.postRequest<Subscription>(url, {});
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}
